import { Auth } from "@aws-amplify/auth";
import { Form, Input, message, Typography, Button } from "antd";
import { LanguageChange } from "shared/components";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router";
import { useDispatch } from "react-redux";
import { cadastroRealizado } from "explorer/reducers/auth";
import { ReactComponent as Logo } from "shared/assets/images/logo-strm.svg";
import { isMobile } from "react-device-detect";
import "../login/Login.scss";

const VerificacaoLogin: React.FC<RouteComponentProps> = (props) => {
  const { history, location } = props;
  const [form] = Form.useForm();
  const usuario: any = location.state;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onFinish = async () => {
    try {
      const values = await form.validateFields();
      await Auth.confirmSignUp(usuario.login, `${values.codigo}`);
      message.success(t("pages.VerificacaoLogin.sucesso"));
      dispatch(cadastroRealizado());
      history.push("/login");
    } catch {
      message.error(t("pages.VerificacaoLogin.error"));
    }
  };

  const onClickReenvia = async () => {
    await Auth.resendSignUp(usuario.login);
    message.info(t("pages.VerificacaoLogin.mensagemReenvio"), 10);
  };

  return (
    <div
      className="conteudo-centralizado login"
      style={{
        height: "100vh",
        backgroundColor: "#1a191a",
        padding: "14px 26px",
      }}
    >
      <div className="direction">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div className="logo-region">
            <Logo className="logo" style={{ width: isMobile ? 80 : 100 }} />
            <span style={{ fontSize: isMobile ? 14 : 28 }}>for labels</span>
          </div>
          <LanguageChange.SelectLanguageChange />
        </div>
        <Form form={form} onFinish={onFinish}>
          <div className="content" style={{ marginTop: 154 }}>
            <div className="text">
              <Typography.Title style={{ color: "#F2F2F2", fontSize: 20 }}>
                {t("pages.VerificacaoLogin.titulo")}
              </Typography.Title>
              <Typography.Text style={{ color: "#FFFFFF" }}>
                {t("pages.VerificacaoLogin.verificacaoMensagem")}
              </Typography.Text>
            </div>
            <div className="input">
              <Form.Item
                name="codigo"
                rules={[
                  {
                    required: true,
                    message: t("pages.VerificacaoLogin.codigoObrigatorio"),
                  },
                ]}
                normalize={(value) => value?.trim()}
              >
                <Input
                  placeholder={t("pages.VerificacaoLogin.codigo")}
                  size="large"
                />
              </Form.Item>
            </div>

            <div className="enter-button">
              <button className="botao-roxo" style={{ marginBottom: "16px" }}>
                {t("pages.VerificacaoLogin.submit")}
              </button>
            </div>
            <div className="esqueci-senha">
              <Button
                type="link"
                htmlType="button"
                onClick={onClickReenvia}
                className="button-reset-senha"
                style={{ margin: 0 }}
              >
                {t("pages.VerificacaoLogin.reenvioCodigo")}
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default VerificacaoLogin;
